<!-- <div class="custombg fixed-top">
    <app-header #header></app-header>
    <app-breadcrumb></app-breadcrumb>
</div> -->
<div class="row mt-5">
    <h4 class="ml-4 mt-4 pt-2 mb-3"></h4>
</div>

<div class="pb-4 justify-content-center">
    <form class="form p-0" [formGroup]="AddToolsForm">
        <div class="main-div">
            <div class=" ml-4 mr-4 mt-1 pt-3">
                <div class="col-sm-2">
                    <label id="blue-text"><b>Tool Details</b></label>
                </div>
                <div class="horizontal-rule col-sm-12 row pb-4">
                    <div class="col-sm-6">
                        <label class="labels"><b>Author</b><sup>*</sup></label>
                        <div id="ServiceDropdown" class="form-group mat-card-header ">
                            <select class="form-control ml-1 px-2" formControlName="Author"
                                (change)="getAuthorId($event.target.value)" [(ngModel)]="Author">
                                <option disabled selected value=null>-- Select --</option>
                                <option *ngFor="let author of AuthorIds" [value]="author.employeeId">
                                    {{author.name}}
                                </option>
                            </select>
                            <div *ngIf="AddToolsForm.get('Author').invalid && AddToolsForm.get('Author').errors && 
                                (AddToolsForm.get('Author').dirty || AddToolsForm.get('Author').touched)">
                                <small class="text-danger" *ngIf="AddToolsForm.get('Author').hasError('required')">
                                    This field is required.
                                </small>
                            </div>
                        </div>

                        <label class="labels"><b>Tool Name</b><sup>*</sup></label>
                        <div class="mat-card-header ">
                            <input class="form-control ml-1 py-2 px-2.5" formControlName="toolName"
                                placeholder="Enter tool name.." />
                        </div>
                        <div *ngIf="AddToolsForm.get('toolName').invalid && AddToolsForm.get('toolName').errors && 
                                (AddToolsForm.get('toolName').dirty || AddToolsForm.get('toolName').touched)">
                            <small class="text-danger" *ngIf="AddToolsForm.get('toolName').hasError('required')">
                                This field is required.
                            </small>
                        </div>

                        <label class="labels"><b>Competency</b><sup>*</sup></label>
                        <div class="mat-card-header ">
                            <select class="form-control ml-1 px-2" formControlName="serviceLines"
                                [(ngModel)]="selectedServicelineId" (change)="subCompetencies($event.target.value)">
                                <option disabled selected value=null>-- Select --</option>
                                <option *ngFor="let serviceLine of serviceLinesValues" [value]="serviceLine.id">
                                    {{serviceLine.name}}
                                </option>
                            </select>

                        </div>
                        <div *ngIf="AddToolsForm.get('serviceLines').invalid && AddToolsForm.get('serviceLines').errors && 
                        (AddToolsForm.get('serviceLines').dirty || AddToolsForm.get('serviceLines').touched)">
                            <small class="text-danger" *ngIf="AddToolsForm.get('serviceLines').hasError('required')">
                                This field is required.
                            </small>
                        </div>
                        <label class="labels"><b>KMS URL</b><sup>*</sup></label>
                        <div class="mat-card-header">
                            <input class="form-control ml-1 py-2 px-2.5" formControlName="sharepointURL"
                                placeholder="Enter sharepointUrl.." />
                        </div>
                        <div *ngIf="AddToolsForm.get('sharepointURL').invalid && AddToolsForm.get('sharepointURL').errors && 
                            (AddToolsForm.get('sharepointURL').dirty || AddToolsForm.get('sharepointURL').touched)">
                            <small class="text-danger" *ngIf="AddToolsForm.get('sharepointURL').hasError('required')">
                                This field is required.
                            </small>
                        </div>


                    </div>

                    <div class=" col-sm-6">

                        <label class="labels"><b>Reviewer</b><sup>*</sup></label>
                        <div class="mat-card-header">
                            <select class="form-control ml-1 px-2" formControlName="Reviewer"
                                (change)="getReviewerId($event.target.value)" [(ngModel)]="Reviewer">
                                <option disabled selected value=null>-- Select --</option>
                                <option *ngFor="let reviewerId of ReviwerIds" [value]="reviewerId.employeeId">
                                    {{reviewerId.name}}
                                </option>
                            </select>
                        </div>
                        <div *ngIf="AddToolsForm.get('Reviewer').invalid && AddToolsForm.get('Reviewer').errors && 
                        (AddToolsForm.get('Reviewer').dirty || AddToolsForm.get('Reviewer').touched)">
                            <small class="text-danger" *ngIf="AddToolsForm.get('Reviewer').hasError('required')">
                                This field is required.
                            </small>
                        </div>

                        <label class="labels"><b>Tool Type</b><sup>*</sup></label>
                        <div class="mat-card-header">
                            <select class="form-control ml-1 px-2" formControlName="toolType"
                                (change)="getToolTypeId($event.target.value)" [(ngModel)]="selectedToolTypeId">
                                <option disabled selected value=null>-- Select --</option>
                                <option *ngFor="let tooltype of toolTypeValues" [value]="tooltype.typeId">
                                    {{tooltype.name}}
                                </option>
                            </select>
                        </div>
                        <div *ngIf="AddToolsForm.get('toolType').invalid && AddToolsForm.get('toolType').errors && 
                                (AddToolsForm.get('toolType').dirty || AddToolsForm.get('toolType').touched)">
                            <small class="text-danger" *ngIf="AddToolsForm.get('toolType').hasError('required')">
                                This field is required.
                            </small>
                        </div>
                        <label class="labels"><b>SubCompetency</b><sup>*</sup></label>
                        <div class="mat-card-header">
                            <select class="form-control ml-1 px-2" formControlName="subServiceline"
                                [(ngModel)]="selectedSubServicelineId"
                                (change)="getSubserviceLines($event.target.value)" required>
                                <option disabled selected value=null>-- Select --</option>
                                <option *ngFor="let subServiceLine of subServiceLinesValues"
                                    [value]="subServiceLine.id">
                                    {{subServiceLine.name}}</option>
                            </select>
                        </div>
                        <div *ngIf="AddToolsForm.get('subServiceline').invalid && AddToolsForm.get('subServiceline').errors && 
                        (AddToolsForm.get('subServiceline').dirty || AddToolsForm.get('subServiceline').touched)">
                            <small class="text-danger" *ngIf="AddToolsForm.get('subServiceline').hasError('required')">
                                This field is required.
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="form-group row justify-content-end pr-4" *ngIf="this.viewButton == false">
    <button type="reset" (click)="backToToolsGrid()" class=" btn custom_btn inverted_btn_base me-2 mr-4">Cancel</button>
    <button type="button" class="  custom_btn primary_btn_base rounded" *ngIf="this.createButton == true"
        [disabled]="!AddToolsForm.valid" (click)="createTool()">Create</button>
    <button type="button" class="pr-3 pl-3 pt-1 pb-1 custom_btn primary_btn_base rounded" *ngIf="this.editButton == true"
        [disabled]="!AddToolsForm.valid" (click)="editTool()"> Edit </button>
    <button type="button" class="pr-3 pl-3 pt-1 pb-1 custom_btn primary_btn_base rounded" *ngIf="this.copyButton == true"
        [disabled]="!AddToolsForm.valid" (click)="copyTool()">Save</button>
</div>

<div class="form-group row justify-content-end p-4" *ngIf="this.viewButton == true">
    <button type="button" (click)="backToToolsGrid()" class="btn custom_btn inverted_btn_base btn-lg me-2 mr-4">Back</button>
</div>